import { render } from "./VLoaderDataTables.vue?vue&type=template&id=d99a86d0"
import script from "./VLoaderDataTables.vue?vue&type=script&lang=js"
export * from "./VLoaderDataTables.vue?vue&type=script&lang=js"

import "./VLoaderDataTables.vue?vue&type=style&index=0&id=d99a86d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__